<template>
  <div>
    <div class="row mb-2 pe-4">
      <div class="col-lg-8 col-md-7 col-7 d-flex align-items-center">
        <div class="color-common">
          <h3 class="title-page mb-0 ps-3">Messaging Credits</h3>
        </div>
      </div>
    </div>
    <div class="page-header align-items-start min-vh-100 my-transacions">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="notifications">
            <material-alert
              v-if="error"
              color="danger"
              icon="ni ni-like-2 ni-lg"
              dismissible
            >
              {{ error }}
            </material-alert>
          </div>
          <h5 class="mt-4 ps-3">Messaging Credit - WhatsAPP</h5>
          <h6
            class="ps-3"
            style="color: green; width: fit-content; cursor: pointer"
            @click="showWaSumary()"
          >
            CURRENT CREDIT BALANCE: {{ whatsAppBal }} <span class="text-muted" style="font-size: 14px;">(Transactional: 1 credit, Marketing: 4 credits)</span>
          </h6>
          <div class="col-lg-12 col-md-12 col-12 mx-auto" v-if="isLoadData">
            <div class="row mt-4">
              <div class="col-6">
                <div class="card-custom">
                  <div class="px-0 pb-2">
                    <div class="table-responsive p-0 custom-table">
                      <table class="table align-items-center mb-0">
                        <thead>
                          <tr>
                            <th class="text-center font-weight-bolder w-4">
                              Quantity
                            </th>
                            <th class="text-center font-weight-bolder w-4">
                              Price
                            </th>
                            <th class="text-center font-weight-bolder w-4">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody v-if="dataWa.length">
                          <tr v-for="(value, key) in dataWa" :key="key">
                            <td class="text-center text-xss">
                              <span v-if="value.starLabel">
                                <i class="fa fa-star text-warning"></i>
                              </span>
                              {{ value.quantityLabel }}
                            </td>
                            <td class="text-center text-xss">
                              <div
                                v-if="value.originalPrice"
                                class="price-display"
                              >
                                <div class="original-price">
                                  ${{ value.originalPrice }}
                                </div>
                                <div class="discounted-price text-danger">
                                  ${{ value.price }}
                                </div>
                              </div>
                              <div v-else>
                                {{ value.priceLabel }}
                              </div>
                            </td>
                            <td class="text-center text-xss">
                              <material-button
                                @click="processPayment(value, true)"
                                class="btn-background"
                              >
                                Pay
                              </material-button>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="5" class="text-center">
                              No item available
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="d-flex justify-content-center gap-3 sample-images-wrapper">
                  <div class="sample-image-item text-center">
                    <div class="sample-label">Marketing whatApp samples</div>
                    <img src="@/assets/img/marketing-sample.jpeg" alt="Marketing sample images" class="sample-image">
                  </div>
                  <div class="sample-image-item text-center">
                    <div class="sample-label">Transactional</div>
                    <img src="@/assets/img/transactional-sample.jpeg" alt="Transactional sample images" class="sample-image">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <a
            id="nav_item_2"
            class="nav-link"
            href="/wa-payment-history"
            style="color: blue; text-decoration: underline"
          >
            Payment History
          </a>
        </div>
        <div class="row">
          <div class="notifications">
            <material-alert
              v-if="error"
              color="danger"
              icon="ni ni-like-2 ni-lg"
              dismissible
            >
              {{ error }}
            </material-alert>
          </div>
          <h5 class="mt-4 ps-3">Messaging Credit - SMS</h5>
          <h6
            class="ps-3"
            style="color: green; width: fit-content; cursor: pointer"
            @click="showSmsSumary()"
          >
            CURRENT SMS CREDIT BALANCE: {{ smsBal }}
          </h6>
          <div class="col-lg-12 col-md-12 col-12 mx-auto" v-if="isLoadData">
            <div class="row mt-4">
              <div class="col-12">
                <div class="card-custom">
                  <div class="px-0 pb-2">
                    <div class="table-responsive p-0 custom-table">
                      <table class="table align-items-center mb-0">
                        <thead>
                          <tr>
                            <th class="text-center font-weight-bolder w-4">
                              Quantity
                            </th>
                            <th class="text-center font-weight-bolder w-4">
                              Price
                            </th>
                            <th class="text-center font-weight-bolder w-4">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody v-if="data.length">
                          <tr v-for="(value, key) in data" :key="key">
                            <td class="text-center text-xss">
                              {{ value.quantityLabel }}
                            </td>
                            <td class="text-center text-xss">
                              {{ value.priceLabel }}
                            </td>
                            <td class="text-center text-xss">
                              <material-button
                                @click="processPayment(value, false)"
                                class="btn-background"
                              >
                                Pay
                              </material-button>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="5" class="text-center">
                              No item available
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <a
            id="nav_item_2"
            class="nav-link"
            href="/sms-payment-history"
            style="color: blue; text-decoration: underline"
          >
            Payment History
          </a>
        </div>
      </div>
      <div>
        <button
          style="display: none"
          type="button"
          id="show-sms-sumary-method-modal"
          data-bs-toggle="modal"
          data-bs-target="#modalSmsSumary"
        ></button>
        <div
          class="modal fade"
          id="modalSmsSumary"
          tabindex="-1"
          aria-hidden="true"
        >
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">SMS Sumary</h5>
              </div>
              <div class="modal-body">
                <div style="margin-bottom: 30px">
                  Begining Bal of the month({{ currentFirstMonth }}) :
                  {{ begining }}
                </div>
                <div style="margin-bottom: 30px">
                  Total Purchase this month: {{ total_purchase }}
                </div>
                <div style="margin-bottom: 30px">
                  Total Use Month-to-Date: {{ total_use }}
                </div>
                <div style="margin-bottom: 30px">
                  Current Balance: {{ smsBal }}
                </div>
              </div>
              <!-- Modal content-->
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-primary btn-close-modal btn-sm"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <button
          style="display: none"
          type="button"
          id="show-wa-sumary-method-modal"
          data-bs-toggle="modal"
          data-bs-target="#modalWaSumary"
        ></button>
        <div
          class="modal fade"
          id="modalWaSumary"
          tabindex="-1"
          aria-hidden="true"
        >
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">WhatsApp Sumary</h5>
              </div>
              <div class="modal-body">
                <div style="margin-bottom: 30px">
                  Begining Bal of the month({{ currentFirstMonth }}) :
                  {{ wa_begining }}
                </div>
                <div style="margin-bottom: 30px">
                  Total Purchase this month: {{ wa_total_purchase }}
                </div>
                <div style="margin-bottom: 30px">
                  Total Use Month-to-Date: {{ wa_total_use }}
                </div>
                <div style="margin-bottom: 30px">
                  Current Balance: {{ whatsAppBal }}
                </div>
              </div>
              <!-- Modal content-->
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-primary btn-close-modal btn-sm"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="position-fixed top-1 end-1 z-index-2 message-success">
    <material-snackbar
      v-if="snackbar === 'danger' || snackbar === 'success'"
      title=""
      date=""
      :description="message"
      :icon="{ component: 'campaign', color: 'white' }"
      :color="snackbar"
      :close-handler="closeSnackbar"
    />
  </div>
  <material-loading :active="loaderActive" />
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import "bootstrap/js/dist/modal";
import MaterialButton from "@/components/MaterialButton.vue";
import "@vuepic/vue-datepicker/dist/main.css";
import SmsSetupService from "../../../services/smsSetup.service";
import AirwallexService from "../../../services/airwallex.service";
import TokenService from "../../../services/token.service";
import moment from "moment";

export default {
  name: "find-store",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    MaterialButton,
  },
  data() {
    return {
      message: "",
      snackbar: null,
      loaderActive: false,
      // Merchant's preferred gateway for card payments (1 = Stripe, 3 = Airwallex).
      defaultPaymentMode: 1,
      data: [
        {
          id: 1,
          price: 100, // 500 sms
          priceLabel: "$ 100",
          quantity: 1000,
          quantityLabel: "1000 SMS Credits",
        },
        {
          id: 2,
          price: 180, // 2000 sms
          priceLabel: "$ 180",
          quantity: 2000,
          quantityLabel: "2000 SMS Credits",
        },
        {
          id: 3,
          price: 380, // 5000 sms
          priceLabel: "$ 380",
          quantity: 5000,
          quantityLabel: "5000 SMS Credits",
        },
      ],
      dataWa: [
        {
          id: 1,
          price: 160, // 2000 WA sms
          priceLabel: "$ 160",
          quantity: 2000,
          quantityLabel: "2000 Credits",
        },
        {
          id: 2,
          price: 350, // 5000 WA sms
          priceLabel: "$ 350",
          quantity: 5000,
          quantityLabel: "5000 Credits",
        },
        {
          id: 3,
          price: 650, // 12000 WA sms with discount
          originalPrice: 780,
          priceLabel: "U.P. $780 Price: $650",
          starLabel: true,
          quantity: 12000,
          quantityLabel: "12000 Credits",
        },
        {
          id: 4,
          price: 1100, // 22000 WA sms with discount
          originalPrice: 1430,
          priceLabel: "U.P. $1430 Price: $1100",
          starLabel: true,
          quantity: 22000,
          quantityLabel: "22000 Credits",
        },
      ],
      isLoadData: false,
      token: TokenService.getLocalAccessToken(),
      merchantCodeExport: localStorage.getItem("MERCHANT_CODE", ""),
      smsBal: 0,
      whatsAppBal: 0,
      currentFirstMonth: moment().startOf("month").format("DD/MM/YYYY"),
    };
  },
  created() {
    var session_id = this.$route.query.session_id;
    var airwallex_intent_id = this.$route.query.airwallex_intent_id;
    var quantity = this.$route.query.quantity;
    var price = this.$route.query.price;
    var feature_type = this.$route.query.feature_type;

    // Fetch merchant default payment mode (1 = Stripe, 3 = Airwallex) so
    // processPayment can pick the right gateway. processPayment awaits this,
    // so a quick click cannot go to Stripe before the mode has loaded.
    this.paymentModeLoaded = SmsSetupService.getDefaultPaymentMode().then(
      (response) => {
        if (response.data.result.isSuccess) {
          this.defaultPaymentMode =
            parseInt(response.data.data.default_payment_mode) || 1;
        }
      },
      () => {},
    );

    if (session_id) {
      // Stripe return.
      this.showLoader();
      this.isLoadDone = false;

      if (feature_type === "sms") {
        this.addCredit({
          session_id: session_id,
          price: price,
          sms_bal: quantity,
        });
      } else if (feature_type === "whatsapp") {
        SmsSetupService.checkCheckoutSessionStripe({ stripe_id: session_id }, this.merchantCodeExport).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.message = "WhatsApp Credit Successfully!";
              this.snackbar = "success";
              this.setTimeOutNotification();

              this.$router.replace({
                path: this.$route.path,
                query: {}
              });
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
          }
        );
      }

      setTimeout(() => {
        this.getList();
      }, 3000);
    } else if (airwallex_intent_id) {
      // Airwallex HPP return. Both SMS and WhatsApp credits are applied by
      // ProcessWebhookJob once Airwallex confirms the payment (webhook, or
      // /payment/check-hpp-airwallex below if we get here first) — with the
      // quantity the checkout priced, not the one in this URL.
      this.showLoader();
      this.isLoadDone = false;

      if (feature_type === "sms" || feature_type === "whatsapp") {
        const successMessage =
          feature_type === "sms" ? "Sms Credit Successfully!" : "WhatsApp Credit Successfully!";
        // An SMS checkout started on the previous release made an untagged
        // intent the job does not credit; add-sms-bal still credits that one
        // (verified with Airwallex) and is a no-op for every other intent.
        const legacySmsCredit =
          feature_type === "sms"
            ? SmsSetupService.addSmsBal({
                airwallex_intent_id: airwallex_intent_id,
                price: price,
                sms_bal: quantity,
              }).catch(() => {})
            : Promise.resolve();
        legacySmsCredit.then(() =>
          SmsSetupService.checkHppAirwallex(
            { payment_intent_id: airwallex_intent_id },
            this.merchantCodeExport,
          )
        ).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.message = successMessage;
              this.snackbar = "success";
              this.setTimeOutNotification();

              this.$router.replace({
                path: this.$route.path,
                query: {},
              });
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message =
              error?.response?.data?.result?.message ?? "Airwallex check failed";
            this.hideLoader();
          },
        );

        setTimeout(() => {
          this.getList();
        }, 3000);
      }
    }

    if (
      this.merchantCodeExport === "luckypanda" &&
      process.env.VUE_APP_NODE_ENV !== "staging"
    ) {
      this.data = [
        {
          id: 1,
          price: 100, // 500 sms
          priceLabel: "$ 100",
          quantity: 1000,
          quantityLabel: "1000 SMS Credits",
        },
        {
          id: 2,
          price: 140, // 2000 sms
          priceLabel: "$ 140",
          quantity: 2000,
          quantityLabel: "2000 SMS Credits",
        },
        {
          id: 3,
          price: 295, // 5000 sms
          priceLabel: "$ 295",
          quantity: 5000,
          quantityLabel: "5000 SMS Credits",
        },
      ];
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    addCredit(data) {
      const successMessage = "Sms Credit Successfully!";

      SmsSetupService.addSmsBal(data).then(
        (response) => {
          const { result, data: responseData } = response.data;

          if (result.isSuccess && responseData) {
            this.smsBal = responseData.sms_balance;
            this.snackbar = "success";
            this.message = successMessage;
            this.setTimeOutNotification();

            this.$router.replace({
              path: this.$route.path,
              query: {}
            });
          } else if (result.isSuccess && !responseData) {
            window.location.href = "/sms-and-wa-setup";
          } else {
            this.snackbar = "danger";
            this.message = result.message;
            this.setTimeOutNotification();
          }

          this.isLoadDone = true;
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
        }
      );
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    getList() {
      this.isLoadData = false;
      this.showLoader();
      SmsSetupService.getSmsBal().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.smsBal = response.data.data.smsBal;
            this.begining = response.data.data.begining;
            this.total_purchase = response.data.data.total_purchase;
            this.total_use = response.data.data.total_use;
            this.isLoadData = true;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );

      SmsSetupService.getWaBal().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.whatsAppBal = response.data.data.waBal;
            this.wa_begining = response.data.data.begining;
            this.wa_total_purchase = response.data.data.total_purchase;
            this.wa_total_use = response.data.data.total_use;
            this.isLoadData = true;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    showLoader() {
      this.loaderActive = true;
    },
    hideLoader() {
      this.loaderActive = false;
    },
    async processPayment(item, isWa = false) {
      var url = window.location.href.split("?")[0];
      // Wait for the gateway lookup started in created(); until it resolves
      // defaultPaymentMode is still the Stripe default.
      this.showLoader();
      await this.paymentModeLoaded;
      const useAirwallex = this.defaultPaymentMode === 3;

      // Stripe substitutes {CHECKOUT_SESSION_ID}; Airwallex HPP appends
      // `airwallex_intent_id` server-side onto whatever success_url we send.
      const successUrl = useAirwallex
        ? `${url}?price=${item.price}&quantity=${item.quantity}&feature_type=${
            isWa ? "whatsapp" : "sms"
          }`
        : `${url}?session_id={CHECKOUT_SESSION_ID}&price=${
            item.price
          }&quantity=${item.quantity}&feature_type=${
            isWa ? "whatsapp" : "sms"
          }`;

      var data = {
        success_url: successUrl,
        cancel_url: url,
        images: "",
        name: item.quantityLabel,
        unit_amount: item.price,
        quantity: 1,
        isWATopupOnMerchant: isWa ? 1 : null,
      };
      this.showLoader();

      let serviceMethod;
      if (useAirwallex) {
        serviceMethod = isWa
          ? SmsSetupService.checkoutHppAirwallexForWa
          : SmsSetupService.checkoutHppAirwallexForSms;
      } else {
        serviceMethod = isWa
          ? SmsSetupService.checkoutSessionStripeForWa
          : SmsSetupService.checkoutSessionStripeForSms;
      }

      serviceMethod(data).then(
        (response) => {
          if (response.data.result.isSuccess) {
            if (useAirwallex) {
              // Loader stays up while the SDK loads and navigates away.
              AirwallexService.redirectToHpp(response.data.data, () => this.hideLoader()).catch((error) => {
                console.error(error);
                this.snackbar = "danger";
                this.message = this.$t("Airwallex_checkout_failed");
                this.hideLoader();
                this.setTimeOutNotification();
              });
              return;
            }
            window.location.href = response.data.data.url;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message =
            error?.response?.data?.result?.message ?? error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    showSmsSumary() {
      const modalSmsSumary = document.getElementById(
        "show-sms-sumary-method-modal"
      );
      modalSmsSumary.click();
    },
    showWaSumary() {
      const modalWaSumary = document.getElementById(
        "show-wa-sumary-method-modal"
      );
      modalWaSumary.click();
    },
  },
};
</script>
<style scoped>
.text-title {
  color: #133067 !important;
  font-weight: 600 !important;
  font-size: 20px !important;
  font-family: "Roboto Slab", sans-serif !important;
}

.text-label {
  color: #5b848d !important;
  font-weight: 500 !important;
  font-size: 17px !important;
  font-family: "Roboto Slab", sans-serif !important;
}

.checkbox-auto-save label {
  padding-top: 11px !important;
}

.custom-name {
  word-break: break-all;
  max-width: 200px;
  white-space: normal;
}

.wrap-action .form-check:first-child {
  padding-left: 2px;
}

.multiselect {
  min-width: 135px;
}

.r-no-expiry .form-check {
  padding-left: 0 !important;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 50%;
    margin: 1.75rem auto;
  }
}

.price-display {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.original-price {
  font-size: 12px;
  text-decoration: line-through;
}

.discounted-price {
  font-size: 14px;
  font-style: italic;
}

.sample-images-wrapper {
  flex-wrap: nowrap;
}

.sample-image-item {
  flex: 0 0 auto;
}

.sample-label {
  font-size: 14px;
}

.sample-image {
  width: 100%;
  max-width: 280px;
  height: auto;
  display: block;
}
</style>
